import { IMaterial } from "../materials";

export interface ITransaction {
    id: number;
    materialId: number;
    type: string;
    date?: Date;
    createdBy?: string;
    quantity: string;
    trackingNumber?: string;
    workOrderId?: number;
    comment?: string;
    reasonId: string;
}

const newTransaction = (): ITransaction => ({
    id: 0,
    materialId: 0,
    type: '',
    quantity: '',
    reasonId: ''
})

export const createTransaction = <T extends Partial<ITransaction>>(initialValues: T): ITransaction & T => {
    return Object.assign(newTransaction(), initialValues);
};

export const createTransactionFromMaterial = (material: IMaterial): ITransaction => {
    let transaction = Object.assign(newTransaction(), {});
    transaction.materialId = material.id;
    return transaction;
};